import {Trans} from '@lingui/macro';
import React, {FC} from 'react';
import styled from 'styled-components';

import {KeyboardActionsEnum} from '../../../../../../libs/shared/helpers/src/browser/keyboardHelpers';
import {Handler} from '../../../../../../libs/shared/helpers/src/react/reactHelpers';
import {Button} from '../../../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {KeyboardShortcuts} from '../../../../../../libs/shared/ui/src/components/keyboard/keyboardShortcuts';

/*
 * Props.
 */

export interface DoneToolbarButtonProps {
  doneWithMessage: Handler;
}

/*
 * Style.
 */

const StyledButtonDiv = styled.div`
  padding: 0 8px;
`;

/*
 * Component.
 */

export const DoneToolbarButton: FC<DoneToolbarButtonProps> = ({doneWithMessage}) => {
  const keyHandlers = {
    [KeyboardActionsEnum.SEND]: doneWithMessage,
    [KeyboardActionsEnum.SEND_AND_DONE]: doneWithMessage,
  };

  return (
    <KeyboardShortcuts handlers={keyHandlers}>
      <StyledButtonDiv>
        <Button variant={ButtonVariantsEnum.PRIMARY} onClick={doneWithMessage}>
          <Trans id="composer-done">Done</Trans>
        </Button>
      </StyledButtonDiv>
    </KeyboardShortcuts>
  );
};
